import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductOption extends BaseEntity {

  productOptionCode       : string;
  name                    : string;
  rank                    : string;
  productCategoryName     : string;
  productCategoryCode     : string;
  productCategoryTypeName : string;
  productCategoryTypeCode : string;
   
}